import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgBagIconSecondary from './svgs/BagIconSecondary.js';
import SvgBagIcon from './svgs/BagIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var bagIcon = (props => useIcon(SvgBagIcon, SvgBagIconSecondary, props));

export { bagIcon as default };
